// @flow
import BaseModel from 'Stores/BaseModel';
import DealerModel from 'Stores/DealerModel';

export default class AccessoryModel extends BaseModel {
  id: string = '';
  partNumber: string = '';
  accessoryName: string = '';
  nameExtension: string = '';
  partNumberFormatted: string = '';
  carlineName: string = '';
  categoryLabel: string = '';
  marketingCopyText: string = '';
  remarks: string = '';
  specification: string = '';
  includeInOAC: boolean = true;
  mainImages: Array<string> = [];
  rrpInclVAT: number = 0;
  fittingTime: number = 0;
  dealer: DealerModel;

  constructor(data: Object = {}, dealer: DealerModel) {
    super();

    if ((!dealer) instanceof DealerModel) {
      throw new Error('AccessoryModel needs an injected instance of DealerModel');
    }

    this.hydrate(data);
    this.id = data.partNumber;
    this.dealer = dealer;
  }

  getMainImage(): string {
    if (this.mainImages.length > 0) {
      return this.mainImages[0];
    }
    return '';
  }

  showPriceWithFittingCosts() {
    return this.dealer.hourlyRate > 0 && this.fittingTime > 0;
  }

  getTitle(): string {
    return `${this.accessoryName} ${this.nameExtension || ''}`.trim();
  }

  priceInclFitting(): string {
    let price: number;

    if (this.showPriceWithFittingCosts()) {
      price = this.rrpInclVAT + this.dealer.hourlyRate * parseFloat(this.fittingTime);
    } else {
      price = this.rrpInclVAT;
    }

    if (this.dealer.partAccessoryDiscount > 0) {
      price = price - (this.rrpInclVAT * this.dealer.partAccessoryDiscount) / 100;
    }

    return String(Number(price).toFixed(2)).replace('.', ',');
  }
}
